import React from 'react';
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from '@mui/material';
import { ContentCopy } from '@mui/icons-material';
import MfAlert from '../UI/Alert/MfAlert';
import ShareButton from './ShareButton';
import useBorrowerReferralLink from './useBorrowerReferralLink';
import useClosableSnackbar from '../../hooks/useClosableSnackbar';

const ReferralLinkComponent = () => {
  const [referralLink] = useBorrowerReferralLink();
  const { showSnackbar } = useClosableSnackbar();

  return (
    <>
      <MfAlert severity="info">
        Заёмщик, зарегистрировавшийся по вашей уникальной реферальной ссылке,
        автоматически закрепляется за вами. Вы получите 1% от полученного им
        займа
      </MfAlert>
      <div>
        <FormControl sx={{ mt: 3 }} variant="outlined" fullWidth>
          <InputLabel shrink htmlFor="outlined-adornment-password">
            Ваша уникальная ссылка для заёмщиков
          </InputLabel>
          <OutlinedInput
            readOnly
            type="text"
            value={referralLink || ' '}
            endAdornment={
              <>
                <InputAdornment position="start">
                  <IconButton
                    onClick={() => {
                      navigator.clipboard.writeText(referralLink).then(
                        () => {
                          showSnackbar('Ссылка успешно скопирована');
                        },
                        () => {
                          console.log('error copying'); // todo: remove this line
                        }
                      );
                    }}
                    edge="end"
                  >
                    <ContentCopy />
                  </IconButton>
                </InputAdornment>
                <InputAdornment position="end">
                  <ShareButton
                    url={referralLink}
                    title="Получите кредит для действующего бизнеса быстро через инвестиционную платформу Money Friends"
                    description=""
                  />
                </InputAdornment>
              </>
            }
            label="Ваша уникальная ссылка для заёмщиков"
          />
        </FormControl>
      </div>
    </>
  );
};

export default ReferralLinkComponent;
